import styled from "styled-components"

export const IconContainer = styled.i`
  font-size: ${({ size }) => size}px;
  padding: ${({ p }) => p};
  padding-left: ${({ pl }) => pl}px;
  padding-right: ${({ pr }) => pr}px;
  padding-top: ${({ pt }) => pt}px;
  padding-bottom: ${({ pb }) => pb}px;
  margin: ${({ m }) => m};
  margin-right: ${({ mr }) => mr}px;
  margin-left: ${({ ml }) => ml}px;
  margin-top: ${({ mt }) => mt}px;
  margin-bottom: ${({ mb }) => mb}px;
  color: ${({ color }) => (color ? color : "#4B5563")};
  text-decoration: none;
`
